export enum RequestType {
  NewRequest = 'NEW_REQUEST',
  IssueBug = 'ISSUE_BUG',
  Question = 'QUESTION',
}
